/*
 * @Author: zhangdingsong
 * @LastEditTime: 2023-11-27 09:55:21
 */
import { FileItem, NewsItem } from "@root/common/interface/result";
import { addNewsDetailsPV, getNewsDetail } from "@root/common/service";
import { BackTop, Col, Empty, Row, Spin, Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { UpOutlined } from "@ant-design/icons";
import "./_style.scss";
import { store } from "@root/store";
import { setMenuColumnId } from "@root/reducers/menuColumnId";
import { postLeaveAdvertisementTimeMap } from "@root/common/utils";
export default function NewsDetails() {
  const [newsDetail, setNewsDetail] = useState<NewsItem>();
  const [loading, setLoading] = useState(false);

  const { detailId } = useParams();

  const queryNewsDetail = async (detailId: number) => {
    setLoading(true);
    await addNewsDetailsPV(detailId);
    const { data } = await getNewsDetail(detailId);
    if (data.fileList && data.fileList.length > 0) {
      data.fileList = data.fileList.filter(
        (item) => item.fileUrl && item.fileName
      );
    }
    setNewsDetail(data);
    store.dispatch(setMenuColumnId({ columnId: data.secondColumn }));
    setLoading(false);
  };
  useEffect(() => {
    queryNewsDetail(Number(detailId));
    window.scrollTo(0, 0);
  }, [detailId]);

  const dateFormat = (date: string) => {
    return date && date.split(" ")[0];
  };
  useEffect(() => {
    var startTime = new Date().valueOf() / 1000;
    console.log("newsDetail", newsDetail);

    return () => {
      if (newsDetail) {
        let newsList = [
          {
            id: detailId,
            title: (newsDetail as any).title,
          },
        ];
        postLeaveAdvertisementTimeMap(newsList, startTime, newsList.length, 2);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsDetail]);
  return (
    <div className="news-details-conver">
      <Spin spinning={loading} wrapperClassName={"news-details-conver-spin"}>
        {newsDetail ? (
          <>
            <h1 className="news-title">{newsDetail.title}</h1>
            <Row className="news-info">
              <Col span={8}>
                <span>
                  发布时间：
                  {newsDetail.updateTime && dateFormat(newsDetail.updateTime)}
                </span>
              </Col>
              <Col span={8}>
                <span>来源：{newsDetail.author}</span>
              </Col>
              <Col span={8}>
                <span>阅读：{newsDetail.clickNum}</span>
              </Col>
            </Row>
            <div
              className="news-content"
              dangerouslySetInnerHTML={{ __html: newsDetail.context }}
              onCopy={(e) => e.preventDefault()}
            ></div>
            {newsDetail.fileList && newsDetail.fileList.length > 0 ? (
              <div className="attachment-list">
                <span className="attachment-title">附件：</span>
                <p className="attachment-file-list">
                  {newsDetail.fileList.map((fileItem: FileItem) => {
                    return (
                      <span key={fileItem?.id}>
                        【
                        <a href={fileItem.fileUrl} rel="noreferrer">
                          {fileItem.fileName}
                        </a>
                        】
                      </span>
                    );
                  })}
                </p>
              </div>
            ) : null}
            <BackTop className="back-to-top">
              <div className="to-up-btn">
                <UpOutlined />
                返回顶部
              </div>
            </BackTop>
            {/* <p>
              <Button
                type="primary"
                onClick={() => {
                  Modal.confirm({
                    title: "提示",
                    content: (
                      <p>请联系刘老师获取指南原文 联系方式：1501013123 </p>
                    ),
                    okText: "确认",
                    cancelText: "取消",
                  });
                }}
              >
                下载指南原文
              </Button>
            </p> */}
          </>
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Spin>
    </div>
  );
}
